export default class Toast {
    constructor() {
        this.toasts = []
        this.intervals = []
    }

    /**
     * Добавление в корзину
     * @param {text} text -
     */
    cart(title) {
        let toast = document.createElement("div")
        toast.classList.add("toast", "toast-cart")
        toast.innerHTML = `
            <div class="toast__content">
                <div class="toast__title">${title}</div>
            </div>
            <div class="toast__buttons">
                <a href="/cart" class="toast__cart"></a>
                <div class="toast__close"></div>
            </div>
        `
        this.insertToast(toast)
    }

    /**
     * Сообщение об ошибке
     * @param {*} text
     */
    error(title) {
        let toast = document.createElement("div")
        toast.classList.add("toast", "toast-error")
        toast.innerHTML = `
            <div class="toast__content">
                <div class="toast__title">${title}</div>
            </div>
            <div class="toast__buttons">
                <div class="toast__close"></div>
            </div>
        `
        this.insertToast(toast)
    }

    custom(text) {
        let toast = document.createElement("div")
        toast.classList.add("toast", "toast-error")
        toast.innerHTML = `
            <div class="toast__content">
                <div class="toast__title">${text}</div>
            </div>
            <div class="toast__buttons">
                <div class="toast__close"></div>
            </div>
        `
        this.insertToast(toast)
    }

    /**
     * Сообщение об успехе
     * @param {*} text
     */
    success(text) {
        let toast = document.createElement("div")
        toast.classList.add("toast", "toast-success")
        toast.innerHTML = `
            <div class="toast__content">
                <div class="toast__title">${text}</div>
            </div>
            <div class="toast__buttons">
                <div class="toast__close"></div>
            </div>
        `
        this.insertToast(toast)
    }

    /**
     * Предупреждение
     * @param {*} text
     */
    warn(text) {}

    /**
     *
     * @param {HTMLElement} toast - toast - element
     */
    insertToast(toast) {
        document.body.append(toast)
        toast.classList.add("toast-inserting")
        toast.querySelector(".toast__close").addEventListener("click", () => this.removeToast(toast))
        setTimeout(() => {
            toast.classList.remove("toast-inserting")
            toast.classList.add("toast-inserted")
        }, 500)

        setTimeout(() => {
            this.removeToast(toast)
        }, 3000)
    }

    removeToast(toast) {
        toast.classList.remove("toast-inserted")
        toast.classList.add("toast-removing")
        setTimeout(() => {
            toast.remove()
        }, 550)
    }
}
